import React, { useState, useEffect, useMemo } from "react";
import * as configApi from "../../../config/configApi.js";
import ReactTable from "react-table";
import { withFixedColumnsStickyPosition } from "react-table-hoc-fixed-columns";
import { ColorResult } from "../../../../src/Constant";

const ReactTableFixedColumns = withFixedColumnsStickyPosition(ReactTable);

const Microorganism = ({ t, data }) => {
  const [dataView, setDataView] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedBacterium, setSelectedBacterium] = useState(null);
  const primaryColor = configApi.USE_COLOR;

  useEffect(() => {
    if (data?.listOrder?.length > 0) {
      const result = [];

      data.listOrder.forEach((item) => {
        if (Array.isArray(item.listTestOrderMB)) {
          item.listTestOrderMB.forEach((test) => {
            result.push(test);
          });
        }
      });

      setDataView(result);

      if (result.length > 0) {
        setSelectedTest(result[0]);
        // ✅ Mặc định chọn vi khuẩn đầu tiên nếu có
        if (result[0]?.listBacterium?.length > 0) {
          setSelectedBacterium(result[0].listBacterium[0]);
        } else {
          setSelectedBacterium(null);
        }
      } else {
        setSelectedTest(null);
        setSelectedBacterium(null);
      }
    } else {
      setDataView([]);
      setSelectedTest(null);
      setSelectedBacterium(null);
    }
  }, [data]);

  const ColumnsChiDinh = useMemo(
    () => [
      {
        Header: t("Sample type"),
        filterable: false,
        width: 100,
        headerStyle: { color: primaryColor },
        Cell: ({ row }) => {
          const view = row._original?.sampleInfo?.specimenName || "";
          return <div>{view}</div>;
        },
      },
      {
        Header: t("Testname"),
        filterable: false,
        accessor: "testName",
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Transplant result"),
        filterable: false,
        accessor: "result",
        width: 200,
        headerStyle: { color: primaryColor },
        Cell: ({ value }) => {
          const result = value ? value.toString() : "";
          return (
            <div style={{ width: "100%", textAlign: "center", fontWeight: "bold", color: "#a50808ff" }}>
              {result}
            </div>
          );
        },
      },
    ],
    [t, primaryColor]
  );

  const ColumnsViKhuan = useMemo(
    () => [
      {
        Header: t("BacteriumID"),
        filterable: false,
        accessor: "bacteriumID",
        width: 100,
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Bacterium Name"),
        filterable: false,
        accessor: "bacteriumName",
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Bacterium GroupName"),
        filterable: false,
        accessor: "bacteriumGroupName",
        width: 200,
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Count Bacterium"),
        filterable: false,
        accessor: "countBacterium",
        width: 200,
        headerStyle: { color: primaryColor },
        Cell: ({ value }) => {
          const result = value ? value.toString() : "";
          return <div style={{ width: "100%", textAlign: "center" }}>{result}</div>;
        },
      },
    ],
    [t, primaryColor]
  );

  const ColumnsKhangSinhDo = useMemo(
    () => [
      {
        Header: t("Antibiotic ID"),
        filterable: false,
        accessor: "antibioticID",
        width: 100,
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Antibiotic name"),
        filterable: false,
        accessor: "antibioticName",
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Technique"),
        filterable: false,
        accessor: "techniqueID",
        width: 200,
        headerStyle: { color: primaryColor },
      },
      {
        Header: t("Result"),
        filterable: false,
        accessor: "result",
        width: 200,
        headerStyle: { color: primaryColor },
        Cell: ({ value }) => {
          const result = value ? value.toString() : "";
          return <div style={{ width: "100%", textAlign: "center" }}>{result}</div>;
        },
      },
      {
        Header: t("SRI"),
        filterable: false,
        accessor: "sri",
        width: 200,
        headerStyle: { color: primaryColor },
        Cell: ({ value }) => {
          const result = value ? value.toString() : "";
          return <div style={{ width: "100%", textAlign: "center" }}>{result}</div>;
        },
      },
    ],
    [t, primaryColor]
  );

  const dataBacterium = useMemo(() => {
    return selectedTest?.listBacterium || [];
  }, [selectedTest]);

  const dataAntibiotic = useMemo(() => {
  const bacteria = selectedTest?.listBacterium || [];
  let result = [];

  bacteria.forEach((b) => {
    if (Array.isArray(b.listResultAntibiotic)) {
      result = result.concat(b.listResultAntibiotic);
    }
  });

  return result;
}, [selectedTest]);

  return (
    <>
      <div style={{ margin: "5px 0" }}>
        <b>{t("SPECIAL TEST MICROBIOLOGY")}</b>
      </div>

      <div style={{ margin: "5px 0" }}>
        <b>{t("LIST TEST")}</b>
      </div>

      <ReactTableFixedColumns
        data={dataView}
        filterable={false}
        columns={ColumnsChiDinh}
        showPaginationBottom={false}
        pageSize={dataView.length > 2 ? dataView.length : 2}
        noDataText={t("No data")}
        className="-striped -highlight -fixed"
        style={{ height: "calc(33vh - 125px)" }}
        getTrProps={(state, rowInfo) => {
          if (!rowInfo) return {};
          return {
            onClick: () => {
              setSelectedTest(rowInfo.original);
              const firstBacterium = rowInfo.original?.listBacterium?.[0] || null;
              setSelectedBacterium(firstBacterium);
            },
            style: {
              cursor: "pointer",
              backgroundColor:
                selectedTest?.testId === rowInfo.original.testId ? "#d3f3ff" : "white",
            },
          };
        }}
      />

      <div style={{ margin: "5px 0" }}>
        <b>{t("LIST BACTERIUM")}</b>
      </div>

      <ReactTableFixedColumns
        data={dataBacterium}
        filterable={false}
        columns={ColumnsViKhuan}
        showPaginationBottom={false}
        pageSize={dataBacterium.length > 2 ? dataBacterium.length : 2}
        noDataText={t("No data")}
        className="-striped -highlight -fixed"
        style={{ height: "calc(33vh - 125px)" }}
        getTrProps={(state, rowInfo) => {
          if (!rowInfo) return {};
          return {
            onClick: () => {
              setSelectedBacterium(rowInfo.original);
            },
            style: {
              cursor: "pointer",
              backgroundColor:
                selectedBacterium?.bacteriumID === rowInfo.original.bacteriumID ? "#d3f3ff" : "white",
            },
          };
        }}
      />

      <div style={{ margin: "5px 0" }}>
        <b>{t("INHIBITORY CONCENTRATION OF ANTIBIOTICS RESULT")}</b>
      </div>

      <ReactTableFixedColumns
        data={dataAntibiotic}
        filterable={false}
        columns={ColumnsKhangSinhDo}
        showPaginationBottom={false}
        pageSize={dataAntibiotic.length > 10 ? dataAntibiotic.length : 10}
        noDataText={t("No data")}
        className="-striped -highlight -fixed"
        style={{ height: "calc(33vh - 125px)" }}
      />
    </>
  );
};

export default Microorganism;
